<template>
  <OfflineIndicator />
  <router-view v-slot="{ Component }">
    <transition name="fade" mode="out-in">
      <component :is="Component" />
    </transition>
  </router-view>
  <div v-if="routeLoading" class="route-loading-bar"></div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { OfflineIndicator } from '@/components/common'
import { useAuthStore } from '@/stores/auth'
import { prefetchRoute } from '@/router/prefetch'

const router = useRouter()
const authStore = useAuthStore()
const routeLoading = ref(false)

// ─── 路由切换加载指示 ────────────────────────────
router.beforeEach(() => { routeLoading.value = true })
router.afterEach(() => { routeLoading.value = false })

// ─── 空闲时预加载路由组件 ──────────────────────
function prefetchRoutes() {
  const candidates = [
    { path: '/classes', permission: 'class:view' },
    { path: '/students', permission: 'student:read' },
    { path: '/questions', permission: 'question:read' },
    { path: '/homeworks', permission: 'homework:read' },
    { path: '/corrections', permission: 'grading:own' },
  ].filter(item => authStore.hasPermission(item.permission))
  const schedule = window.requestIdleCallback || ((cb: () => void) => setTimeout(cb, 1))
  candidates.forEach((item, index) => {
    schedule(() => setTimeout(() => prefetchRoute(item.path), index * 350))
  })
}

onMounted(() => {
  setTimeout(prefetchRoutes, 2000)
})
</script>

<style>
.route-loading-bar {
  position: fixed;
  top: 0;
  left: 0;
  height: 3px;
  background: linear-gradient(90deg, #0F766E, #667eea);
  z-index: 9999;
  animation: loading-slide 1.5s ease-in-out infinite;
}
@keyframes loading-slide {
  0% { width: 0; left: 0; }
  50% { width: 60%; left: 20%; }
  100% { width: 0; left: 100%; }
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.15s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
